import axios from '../utils/axios'

// 未注册邀请评价
export function NoLoginSubmitEvaluateOrder (data = {}) {
  return axios({
    url: '/NoAuth/Evaluate/SubmitEvaluateOrder',
    method: 'post',
    data: data
  })
}

// 已注册邀请评价
export function LoginSubmitEvaluateOrder (data = {}) {
  return axios({
    url: '/Evaluate/Evaluate/SubmitEvaluateOrder',
    method: 'post',
    data: data
  })
}

// 抽奖领取免单卡
export function GetFreeCard (data = {}) {
  return axios({
    url: '/Evaluate/Evaluate/GetFreeCard',
    method: 'post',
    data: data
  })
}
